import React, { useState } from "react";
import { SherbetLogo } from "../../../styles/images/svg/SherbetLogo";
import profile from "../../../styles/images/png/profile.png";
import LogoutIcon from "../../../styles/images/png/LogoutButton.png";
import Box from '@mui/material/Box';
import Badge from "@mui/material/Badge";
import { NotificationActive, NotificationIcon, CloseBlackIcon, DeleteIcon } from "../../../styles/images/svg/notificationIcons";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AddIcon from '@mui/icons-material/Add';
import { Grid } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MobileSidebar from "../sidebar/MobileSidebar";


export const TopNavBar = (props) => {
     const [isPopupOpen, setIsPopupOpen] = useState(false);
     const [isSideBarOpen, setSideBarOpen] = useState(false);

     const handleClose = () => {
          setIsPopupOpen(!isPopupOpen);
     };

     const handleNotificationClick = () => {
          setIsPopupOpen(!isPopupOpen);
     };

     const handleContent = () => {

     };

     const [expanded, setExpanded] = React.useState(false);

     const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
     };

     const handleMobileSidebar = () => {
          setSideBarOpen(!isSideBarOpen)
     }



     return (
          <>
               <MobileSidebar open={isSideBarOpen} iconHandleClick={handleMobileSidebar} />
               <div className="sbt-topnav-wr">
                    <span onClick={handleMobileSidebar} className="sba-hamberger-menu"><MenuIcon/></span>
                    <div className="sbt-topnav-wr__left">
                         <SherbetLogo />
                    </div>
                    <div className="sbt-topnav-wr__right">
                         <div className="sbt-topnav-wr__right_notification">
                              {props.newNotification ? (
                                   <Badge badgeContent={50} color="error" className="sba-notification-badge">
                                        <span onClick={handleNotificationClick}>
                                             <NotificationActive color="action" />
                                        </span>

                                        {isPopupOpen &&
                                             <Box
                                                  width={450}
                                                  my={4}
                                                  alignItems="center"
                                                  gap={4}
                                                  p={2}
                                                  sx={{
                                                       border: '1px solid #ececec',
                                                       position: "absolute",
                                                       backgroundColor: "#ffffff",
                                                       zIndex: "10",
                                                       right: "0",
                                                       marginTop: "48px",
                                                       maxHeight: "300px",
                                                       overflowY: "auto",
                                                  }}
                                             >

                                                  <div className="sba-accordion-header">
                                                       <h4>My Notifications </h4>
                                                       <span onClick={handleClose}>
                                                            <CloseBlackIcon />
                                                       </span>
                                                  </div>
                                                  {/* first accordion */}
                                                  <div className="sba-notification-accordion">
                                                       <Grid className="sba-notification-accordion-content">
                                                            <Accordion className='sba-filter-accor'
                                                                 expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                                                 <AccordionSummary
                                                                      expandIcon={<AddIcon onClick={handleContent} />}
                                                                      aria-controls="panel"
                                                                      id="panel1bh-header"
                                                                      className="sba-accordian-date"
                                                                 >

                                                                      <div className="sba-heading-top-wr">
                                                                           <div className="sba-heading-notification-date">
                                                                                <span>
                                                                                     9 Jan
                                                                                </span>
                                                                           </div>
                                                                           <div className="sba-notification-heading-wr">
                                                                                <h5>
                                                                                     Adidas Sale
                                                                                </h5>
                                                                                <span>
                                                                                     Lorem Ipsum is simply dummy text
                                                                                </span>
                                                                           </div>
                                                                      </div>

                                                                 </AccordionSummary>
                                                                 <div className="sba-accordian-box">
                                                                      <AccordionDetails >
                                                                           <div className="sba-notification-acc">
                                                                                <div className="sba-notification-expand-text"></div>
                                                                                <div className="sba-notification-left-wr-content">
                                                                                     <p>
                                                                                          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                                                     </p>
                                                                                     <div className="sba-notification-delete-icon">
                                                                                          <DeleteIcon />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </AccordionDetails>
                                                                 </div>
                                                            </Accordion>
                                                       </Grid>
                                                  </div>

                                                  {/* second accordion */}
                                                  <div className="sba-notification-accordion">
                                                       <Grid className="sba-notification-accordion-content">
                                                            <Accordion className='sba-filter-accor'
                                                                 expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                                                 <AccordionSummary
                                                                      expandIcon={<AddIcon onClick={handleContent} />}
                                                                      aria-controls="panel"
                                                                      id="panel2bh-header"
                                                                      className="sba-accordian-date"
                                                                 >

                                                                      <div className="sba-heading-top-wr">
                                                                           <div className="sba-heading-notification-date">
                                                                                <span>
                                                                                     9 Jan
                                                                                </span>
                                                                           </div>
                                                                           <div className="sba-notification-heading-wr">
                                                                                <h5>
                                                                                     Adidas Sale
                                                                                </h5>
                                                                                <span>
                                                                                     Lorem Ipsum is simply dummy text
                                                                                </span>
                                                                           </div>
                                                                      </div>

                                                                 </AccordionSummary>
                                                                 <div className="sba-accordian-box">
                                                                      <AccordionDetails >
                                                                           <div className="sba-notification-acc">
                                                                                <div className="sba-notification-expand-text"></div>
                                                                                <div className="sba-notification-left-wr-content">
                                                                                     <p>
                                                                                          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                                                     </p>
                                                                                     <div className="sba-notification-delete-icon">
                                                                                          <DeleteIcon />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </AccordionDetails>
                                                                 </div>
                                                            </Accordion>
                                                       </Grid>
                                                  </div>

                                                  {/* third accordion */}
                                                  <div className="sba-notification-accordion">
                                                       <Grid className="sba-notification-accordion-content">
                                                            <Accordion className='sba-filter-accor'
                                                                 expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                                                 <AccordionSummary
                                                                      expandIcon={<AddIcon onClick={handleContent} />}
                                                                      aria-controls="panel"
                                                                      id="panel3bh-header"
                                                                      className="sba-accordian-date"
                                                                 >

                                                                      <div className="sba-heading-top-wr">
                                                                           <div className="sba-heading-notification-date">
                                                                                <span>
                                                                                     9 Jan
                                                                                </span>
                                                                           </div>
                                                                           <div className="sba-notification-heading-wr">
                                                                                <h5>
                                                                                     Adidas Sale
                                                                                </h5>
                                                                                <span>
                                                                                     Lorem Ipsum is simply dummy text
                                                                                </span>
                                                                           </div>
                                                                      </div>

                                                                 </AccordionSummary>
                                                                 <div className="sba-accordian-box">
                                                                      <AccordionDetails >
                                                                           <div className="sba-notification-acc">
                                                                                <div className="sba-notification-expand-text"></div>
                                                                                <div className="sba-notification-left-wr-content">
                                                                                     <p>
                                                                                          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                                                     </p>
                                                                                     <div className="sba-notification-delete-icon">
                                                                                          <DeleteIcon />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </AccordionDetails>
                                                                 </div>
                                                            </Accordion>
                                                       </Grid>
                                                  </div>

                                                  {/* forth accordion */}
                                                  <div className="sba-notification-accordion">
                                                       <Grid className="sba-notification-accordion-content">
                                                            <Accordion className='sba-filter-accor'
                                                                 expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                                                 <AccordionSummary
                                                                      expandIcon={<AddIcon onClick={handleContent} />}
                                                                      aria-controls="panel"
                                                                      id="panel4bh-header"
                                                                      className="sba-accordian-date"
                                                                 >

                                                                      <div className="sba-heading-top-wr">
                                                                           <div className="sba-heading-notification-date">
                                                                                <span>
                                                                                     9 Jan
                                                                                </span>
                                                                           </div>
                                                                           <div className="sba-notification-heading-wr">
                                                                                <h5>
                                                                                     Adidas Sale
                                                                                </h5>
                                                                                <span>
                                                                                     Lorem Ipsum is simply dummy text
                                                                                </span>
                                                                           </div>
                                                                      </div>

                                                                 </AccordionSummary>
                                                                 <div className="sba-accordian-box">
                                                                      <AccordionDetails >
                                                                           <div className="sba-notification-acc">
                                                                                <div className="sba-notification-expand-text"></div>
                                                                                <div className="sba-notification-left-wr-content">
                                                                                     <p>
                                                                                          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                                                                     </p>
                                                                                     <div className="sba-notification-delete-icon">
                                                                                          <DeleteIcon />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </AccordionDetails>
                                                                 </div>
                                                            </Accordion>
                                                       </Grid>
                                                  </div>
                                             </Box>
                                        }
                                   </Badge>
                              ) : (
                                   <NotificationIcon />
                              )}
                         </div>
                         <div className="sbt-topnav-wr__right_profile">
                              <img src={profile} />
                              <h2>
                                   {props.firstName}nimal
                                   <br />
                                   <span>kamal{props.lastName}</span>
                              </h2>
                         </div>
                         <div

                              className="sbt-topnav-wr__right__logout"
                         >
                              <img src={LogoutIcon} />
                         </div>
                    </div>
               </div>
          </>
     );
};
